import { LANGS } from "types/shared";

import ka from "date-fns/locale/ka"
import en from "date-fns/locale/en-US"

export const getDateFNSLocale = (lang: LANGS) => {
  let locale = en
  switch(lang) {

    case(LANGS.KA):
      locale = ka 
      break;

    case(LANGS.EN):
      locale = en
      break;
      
    default:
      locale = en
  }

  return locale
}